import { Stack } from 'react-bootstrap';

import { useTranslate } from '@tolgee/react';

export default function PermissionsTable() {
  const { t } = useTranslate();

  return (
    <div>
      <div className="d-flex justify-content-start mb-5"></div>
      <div>
        <h2 className="">{t('invite.permissions.roles_and_premissions')}</h2>
      </div>
      <div className="d-flex justify-content-end mb-5">
        <Stack direction={'horizontal'} className={'me-2'}>
          <span className={'me-1'}>
            <i className="fa-duotone fa-check text-success"></i>
          </span>
          <span>{t('config.roles.explanation_full_access')}</span>
        </Stack>
        <Stack direction={'horizontal'} className={'me-2'}>
          <span className={'me-1'}>
            <i className="fa-duotone fa-circle-check text-success"></i>
          </span>
          <span>{t('config.roles.explanation_partial_access')}</span>
        </Stack>
        <Stack direction={'horizontal'} className={'me-2'}>
          <span className={'me-1'}>
            <i className="fa-duotone fa-times text-dark"></i>
          </span>
          <span>{t('config.roles.explanation_no_access')}</span>
        </Stack>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th></th>
            <th>{t('config.roles.admin')}</th>
            <th>{t('config.roles.publisher')}</th>
            <th>{t('config.roles.creator')}</th>
            <th>{t('config.roles.guest')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td> {t('invite.permissions.can_access_profile_groups')}</td>
            <td>
              <i className="fa-duotone fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>

          <tr>
            <td> {t('invite.permissions.can_access_clouds')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>

          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> {t('invite.permissions.manage_sbscription')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.manage_team')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t('invite.permissions.create_drafts')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr>
            <td>{t('invite.permissions.edit_drafts')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr>
            <td>{t('invite.permissions.publish_posts')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> {t('invite.permissions.access_to_communication_center')}</td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> {t('invite.permissions.update_social_media_profiles')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>

          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> {t('invite.permissions.connect_social_media_accounts')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.disconnect_social_media_accounts')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
          </tr>
          <tr className="bg-light-secondary">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> {t('invite.permissions.lomavis_connect_access_portal')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.lomavis_connect_approve_posts')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-times"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.lomavis_connect_access_analytics')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.lomavis_connect_access_calendar')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
          </tr>
          <tr>
            <td> {t('invite.permissions.lomavis_connect_upload_media')}</td>

            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fas fa-check text-success"></i>
            </td>
            <td>
              <i className="fa-duotone fa-circle-check text-success"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
